export const eCardDesignsPageData = {
  seo: {
    titleSuffix: 'Templates | Online + Print | Joy',
    descriptionSuffix:
      'templates with free online cards and matching wedding websites. Matching prints available through our amazing print partners.',
    titleProductType: {
      Invitation: 'Wedding Invitation',
      'Save the Date': 'Save the Date',
    },
  },
};
